import React, {useContext} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import EditIrg from '../cmp/EditIrg.js';

function CatDiscountsEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const setRegister=(act,date,val,olddate)=>{
        let newData={...wndData}
        let data=[]
        let found=false
        if (newData) data=newData.register
        if (!data) data=[]
        if(act==='set') {
            const idx=data.findIndex(el=>el.date===date)
            if(idx!==-1){
                data[idx].act=act
                data[idx].value=val
            } 
            else data.push({act,date,value:val,olddate})
        } else if(act==='del'){
            const idx=data.findIndex(el=>el.date===date)
            if(idx!==-1){
                if(olddate) data[idx].act=act
                else data.splice(idx,1)
            } 
            else data.push({act,date,value:val,olddate})
        } else if(act==='mod'){
            if(val==='T00:00:00Z') return
            data.forEach(el=>{
                if(el.date===date){
                    found=true
                    el.date=val
                }
            })
            if(!found) {
                data.push({act,date:val,value:undefined,olddate})
            }
        }
        newData.register=data
        setWndData(newData)
    }

    const saveRegister=(d)=>{
        //console.log('saveRegister')
        //console.log(wndData.register)
        //console.log(d)
        if(wndData.register) {
            if(!d.data) {tabClose();return}
            if(!d.data.id) {tabClose();return}
            if(wndData.register.length===1){
                let newData={status:'set',key:'Discounts',data:{id:d.data.id,updcat:'catDiscounts',updkey:'prc'}}
                if(wndData.register[0].date) newData.data.date=wndData.register[0].date.substring(0, 10)
                if(wndData.register[0].olddate) newData.data.olddate=wndData.register[0].olddate.substring(0, 10)
                if(wndData.register[0].value) newData.data.value=wndData.register[0].value
                if(wndData.register[0].act==='del') newData.status='del'
                saveData(newData,tabClose)
            }
            else{
                let newData={status:'rgo',key:'Discounts',data:{id:d.data.id,updcat:'catDiscounts',updkey:'prc',
                            grp:wndData.register.map(el=>{if(el.olddate) return({...el,date:el.date.substring(0, 10),olddate:el.olddate.substring(0, 10)}); else return({...el,date:el.date.substring(0, 10)})})}}
                saveData(newData,tabClose)
            }

        }
        tabClose()
    }

    const saveValue=()=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,64)
        const parent=wndData.parent || {id:null,name:null}
        const phone=(wndData.phone || '').substring(0,10)
        const code=wndData.code || null
        const address=(wndData.address || '').substring(0,255)
        const canUse=wndData.canUse||'0'
        const mode=wndData.mode||'0'
        const cashless=wndData.cashless||'0'
        const type=wndData.type||'0'

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                //let newData={status:'add',key:'CatDiscounts',data:{name:name,pass:pass1,org:org,role:role}}
                let newData={status:'add',key:'CatDiscounts',data:{name,parent,phone,address,code,canUse,mode,cashless,type}}
                saveData(newData,saveRegister)
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'CatDiscounts',data:{id,name,parent,phone,address,code,canUse,mode,cashless,type}}
                saveData(newData,saveRegister)
            }        
            else saveRegister({data:{id,name,parent,phone,address,code,canUse,mode,cashless,type}})
        }

    }

    let disc_cont=<>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditIrg Capt={localestr('% знижки')} Value={wndData.register} ValueHistory={wndData.price_history} typeVal={'irgDiscounts'} pid={wndData.id} setVal={setRegister} width1='74' width2='60' minus={true}/><br />
            <div style={{minWidth:'20px',display:'inline-block',flexGrow:4,maxWidth:'30px'}}></div>
            <EditCtrl Capt={localestr('Знижка враховується в ціну')} Value={wndData.mode} typeVal={'l_check'} setVal={(d)=>{setValue('mode',d)}} width1='252' width2='0'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:400}}></div>
        </div>
        <EditCtrl Capt={localestr('Доступно для вибору зі списку для користувачів з відповідними правами')} Value={wndData.canUse} typeVal={'l_check'} setVal={(d)=>{setValue('canUse',d)}} width1='292' width2='0'/>
        <EditCtrl Capt={localestr('Можливий продаж по перерахунку (в кредит або по передплаті)')} Value={wndData.cashless} typeVal={'l_check'} setVal={(d)=>{setValue('cashless',d)}} width1='292' width2='0'/>
    </>
    if(wndData.type==='1')
        disc_cont=<>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditIrg Capt={localestr('% бонуса')} Value={wndData.register} ValueHistory={wndData.price_history} typeVal={'irgDiscounts'} pid={wndData.id} setVal={setRegister} width1='74' width2='60' minus={true}/><br />
                <div style={{minWidth:'8px',display:'inline-block',flexGrow:400}}></div>
            </div>
            <EditCtrl Capt={localestr('Доступно для вибору зі списку для користувачів з відповідними правами')} Value={wndData.canUse} typeVal={'l_check'} setVal={(d)=>{setValue('canUse',d)}} width1='292' width2='0'/>
        </>
    if(wndData.type==='2')
        disc_cont=<>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditIrg Capt={localestr('місячна сума')} Value={wndData.register} ValueHistory={wndData.price_history} typeVal={'irgDiscounts'} pid={wndData.id} setVal={setRegister} width1='84' width2='60' minus={true}/><br />
                <div style={{minWidth:'8px',display:'inline-block',flexGrow:400}}></div>
            </div>
            <EditCtrl Capt={localestr('Доступно для вибору зі списку для користувачів з відповідними правами')} Value={wndData.canUse} typeVal={'l_check'} setVal={(d)=>{setValue('canUse',d)}} width1='292' width2='0'/>
        </>

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='16' width2='40' disabled={true}/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Ім\'я клієнта')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='84' width2='246'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldDiscounts'} setVal={(d)=>{setValue('parent',d)}} width1='44' width2='132' />
    </div>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('Телефон')} Value={wndData.phone} typeVal={'text'} setVal={(d)=>{setValue('phone',d)}} width1='66' width2='90'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Картка')} Value={wndData.code} typeVal={'text'} setVal={(d)=>{setValue('code',d)}} width1='50' width2='170'/>
    </div>
    <EditCtrl Capt={localestr('Адреса')} Value={wndData.address} typeVal={'text'} setVal={(d)=>{setValue('address',d)}} width1='54' width2='524'/>
    <EditCtrl Capt={localestr('Тип знижки')} Value={wndData.type} typeVal={'selDiscountType'} setVal={(d)=>{setValue('type',d)}} width1='88' width2='490'/>
        {disc_cont}
    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default CatDiscountsEdit